<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Support Ticket List",
      items: [
        {
          text: "Support Ticket",
          href: "/",
        },
        {
          text: "Ticket List",
          active: true,
        },
      ],
      tickets: [],
        errors:null,
        visible:false,
        message:"",
        search:"",
    };
  },
  mounted() {
    this.getSupportTicketList();
  },
    computed: {
        filteredList() {
            return this.tickets.filter(ticket => {
                return ticket.key.toLowerCase().includes(this.search.toLowerCase())
                    || ticket.support_ticket_subject.name.toLowerCase().includes(this.search.toLowerCase())
                    || (ticket.user.first_name==null ? '' :ticket.user.first_name).toLowerCase().includes(this.search.toLowerCase())
                    || (ticket.user.last_name==null ? '' : ticket.user.last_name).toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search=val;
        },
      async deleteWarning(role) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(role);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getSupportTicketList() {
      try {
        axios
          .get("/api/support-ticket/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.tickets = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data load",
        });
      }
    },
    deleteItem: function deleteItem(role) {
      var _this = this;
      axios
        .post("/api/role_delete/" + role.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          _this.getRoleList();
          _this.hasDeleted = false;
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Booking Key</th>
                    <th>User Name</th>
                      <th>Creation Date</th>
                      <th>Subject</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ticket,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{ticket.key}}</td>
                    <td v-if="ticket.user!=null"><router-link  :to="{ name: 'admin_agent_details', params: {id: ticket.user.id } }" target="_blank" >{{ticket.user.username==null ? 'N/A' : ticket.user.first_name+' '+ticket.user.last_name+' '+ticket.user.username}}</router-link></td>
                      <td v-else> N/A</td>
                      <td>{{ticket.created_at | moment("D MMM YYYY, H:mm")}}</td>
                      <td>{{ticket.support_ticket_subject.name}}</td>
                      <td><router-link :to="{ name: 'support_ticket_history', params: {id: ticket.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Message</router-link></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
